import React, {Component} from "react";
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import $ from "jquery";
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import axios from "axios";
import {Link} from "react-router-dom";
import Switch from "react-switch";
import {BeatLoader} from 'react-spinners';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align: center;
`;
function formatNumber(num) {
    //return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    var n1, n2;
    num = num + '' || '';
    // works for integer and floating as well
    n1 = num.split('.');
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
}
var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(todayDate).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(todayDate).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(todayDate).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};


let x_axis = ["instance_name"]; let y_axis = ["Bank Errors","Config Errors"];
let pie_x_axis = ["Instance Name"]; let pie_y_axis = ["Error Percentage"];
let chartHeight= "300px";
function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}

class SSISProcessLogs extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            loading:true,
            model_visible : false,
            file_url: '',
            rfile: '',
            is_record: true,
            is_exp_button: false,
            ErrGrpLists:[{value:'Bank Errors', label: 'Bank Errors'},{value:'Config Errors', label: 'Config Errors'}],
            fetch_data:false,
            selected_tab: 'success'
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: decoded.object_code,
        });
        this.get_success_packages();
    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
       
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }

    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this.setState({
                isChange:true
            })
        }
    }

    apply_filters(type){
        setTimeout(function(){
        if(type==='success') {
            this.get_success_packages();
        }
        if(type==='failed') {
            this.get_failed_packages();
        }
    }.bind(this), 200);
    }
    get_success_packages(){
        this.setState({
            selected_tab: 'success'
        })
        let that = this;
        let postdatatd2 = {
            start_date: this.state.yestSend,
            end_date: this.state.todSend,

        };
        //alert(idIndex);
        if ($.fn.DataTable.isDataTable('#SSISSuccessTable')) {
            $('#SSISSuccessTable').DataTable().clear().destroy();
        }

        var merchantDataTable1 = $('#SSISSuccessTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                //"scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/InternalReport/ssis-success-alert",
                    type: 'POST',
                    data: postdatatd2,
                    dataSrc:function ( json ) { console.log(json);
                        enabledBody()
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                columns: [
                    {"data":"execution_id"},
                    {"data":"package_name"},
                    {"data":"folder_name"},
                    {"data":"project_name"},
                    {"data":"execution_path"},
                    {"data":"start_time"},
                    {"data":"end_time"},
                    {"data":"execution_duration"},
                    {"data":"execution_result"},
                    {"data":"message"}
                ],
                "columnDefs": [
                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY HH:mm')+'</td>';
                        },
                        "width": "80px",
                        "targets": [5,6]
                    },

                ],

            });

    }

    get_failed_packages(){
        this.setState({
            selected_tab: 'failed'
        })
        var that = this;
        //disabledBody()

        var postData = {
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            selected_tab: 'failed'
        };
        if ($.fn.DataTable.isDataTable('#SSISFailedTable')) {
            $('#SSISFailedTable').DataTable().clear().destroy();
        }
        var SSISFailedTable = $('#SSISFailedTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/InternalReport/ssis-failed-alert",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        enabledBody();
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody()
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },

                columns: [
                    {"data":"execution_id"},
                    {"data":"package_name"},
                    {"data":"folder_name"},
                    {"data":"project_name"},
                    {"data":"execution_path"},
                    {"data":"start_time"},
                    {"data":"end_time"},
                    {"data":"execution_duration"},
                    {"data":"execution_result"},
                    {"data":"message"}
                ],
                "columnDefs": [
                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY HH:mm')+'</td>';
                        },
                        "width": "80px",
                        "targets": [5,6]
                    },

                ],

            });
    }


    reset_all(e){
        this.setState({
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            isChange:true,

        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }


    render() { console.log("sdfsdfsdfsdf", this.state.yestSend);
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "32px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "35px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };


        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">SSIS Process Logs</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">

                                    <div className="">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Date Filter: </label></div>
                                            <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                                                             onEvent={this.handleEvent.bind(this)}  maxDate = {this.state.dateLimit}>
                                                <i className="fa fa-calendar" aria-hidden="true"></i>
                                                <input type="text" name="dateRange"
                                                       className="form-control dateRangeInput"
                                                       value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                                            </DateRangePicker>
                                        </div>


                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {/*{this.state.isChange===true?*/}
                                            {/*    <span className="apply-notification">Please click on Apply button</span>:null*/}
                                            {/*}*/}
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.apply_filters.bind(this, this.state.selected_tab)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <Tabs>
                                        <TabList>
                                            <Tab onClick={()=>this.apply_filters("success")}>Success</Tab>
                                            <Tab onClick={()=>this.apply_filters("failed")}>Failed Alert</Tab>
                                        </TabList>

                                        <TabPanel>
                                           <div>


                                                   <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                       <table id="SSISSuccessTable" className="table table-striped table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th width="100px">Execution id</th>
                                                                    <th>Package name</th>
                                                                    <th width="150px">Folder name</th>
                                                                    <th width="150px">Project name</th>
                                                                    <th width="150px">Execution path</th>
                                                                    <th>Start time</th>
                                                                    <th>End time</th>
                                                                    <th>Execution duration</th>
                                                                    <th>Execution result</th>
                                                                    <th>Message</th>
                                                                    
                                                                </tr>
                                                            </thead>
                                                        <tbody>

                                                        </tbody>
                                                       </table>
                                                   </div>


                                           </div>
                                        </TabPanel>
                                        <TabPanel>
                                            <div>

                                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                    <table id="SSISFailedTable" className="table table-striped table-hover">
                                                        <thead>
                                                        <tr>
                                                            <th width="100px">Execution id</th>
                                                            <th>Package name</th>
                                                            <th width="150px">Folder name</th>
                                                            <th width="150px">Project name</th>
                                                            <th width="150px">Execution path</th>
                                                            <th>Start time</th>
                                                            <th>End time</th>
                                                            <th>Execution duration</th>
                                                            <th>Execution result</th>
                                                            <th>Message</th>
                                                            
                                                        </tr>
                                                        </thead>
                                                        <tbody>

                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </TabPanel>
                                    </Tabs>
                                    {/*<div className="col-md-2 emi-zone-head">Summary Report</div>*/}
                                    {/*<div className="col-md-3 posDetails">*/}
                                    {/*<Link target="_blank"*/}
                                    {/*    to={{*/}
                                    {/*        pathname: "/admin/poser-details",*/}
                                    {/*        filterProps: {*/}
                                    {/*            start_date: this.state.yestSend,*/}
                                    {/*            end_date: this.state.todSend,*/}
                                    {/*            merchants: this.state.merchantID,*/}
                                    {/*            tender_mode: this.state.tenderModeIDs,*/}
                                    {/*            transaction_type: this.state.txnTypeIDs,*/}

                                    {/*        }*/}
                                    {/*    }} >*/}
                                    {/*    POSER Details*/}
                                    {/*</Link>*/}
                                    {/*</div>*/}
                                    <div className="clearfix"></div>


                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV...</p>:<p>Fetching File. Please wait...</p>}
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(SSISProcessLogs)